import React from 'react';

const SelectorDot = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" {...props}>
    <path
      fillRule="evenodd"
      d="M5 0C2.24 0 0 2.24 0 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"
    />
  </svg>
);

export default SelectorDot;
